import {useEffect, useState} from 'react';

// Реактивная media-query. Нужна там, где от ширины зависит не только вид, но и
// поведение — CSS-класса `hidden` тогда мало: пейвол на мобиле не должен даже
// запрашивать озвучку, которую никто не услышит.
const getMatch = (query) => typeof window.matchMedia === 'function' && window.matchMedia(query).matches;

export function useMediaQuery(query) {
    const [matches, setMatches] = useState(() => getMatch(query));

    useEffect(() => {
        if (typeof window.matchMedia !== 'function') return;
        const mql = window.matchMedia(query);
        const onChange = () => setMatches(mql.matches);
        onChange();
        mql.addEventListener('change', onChange);
        return () => mql.removeEventListener('change', onChange);
    }, [query]);

    return matches;
}
